var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10711_392589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4387 4.76167L10.2316 2.5611C10.1674 2.49381 10.0901 2.44023 10.0044 2.40363C9.91877 2.36702 9.82656 2.34814 9.73337 2.34814C9.64017 2.34814 9.54796 2.36702 9.4623 2.40363C9.37665 2.44023 9.29935 2.49381 9.23509 2.5611L7.88271 3.90949L2.61387 9.16163C2.54294 9.23235 2.54294 9.30307 2.47201 9.37497V9.44569L1.33242 12.7813C1.29685 12.9018 1.29118 13.0292 1.31589 13.1524C1.3406 13.2755 1.39495 13.3909 1.47428 13.4885C1.53696 13.558 1.61403 13.6131 1.70017 13.6499C1.78631 13.6867 1.87945 13.7045 1.97314 13.7019C2.01184 13.7067 2.05115 13.7029 2.08817 13.6907C2.1252 13.6784 2.15901 13.6581 2.18711 13.6311L5.5326 12.4949H5.60353C5.67445 12.4949 5.74538 12.4242 5.81749 12.3535L12.4375 5.75293C12.5047 5.68897 12.5582 5.6121 12.5948 5.52696C12.6314 5.44183 12.6504 5.35018 12.6505 5.25755C12.6506 5.16492 12.6319 5.07323 12.5955 4.98801C12.5591 4.90278 12.5058 4.82579 12.4387 4.76167ZM10.9433 5.25907L10.5886 5.61267L9.37695 4.40571L9.73159 4.05211L10.9433 5.25907ZM5.31981 10.866L4.75001 10.2979L4.10929 9.65549L8.38039 5.40051L9.59092 6.60628L5.31981 10.866ZM3.11274 11.8596L3.39763 11.0074L3.96743 11.5755L3.11274 11.8596Z",
    fill: "#CAD9F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10711_392589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEdit);
export default __webpack_public_path__ + "static/media/greyEdit.5def7ecba3b28d5098301876bcb68112.svg";
export { ForwardRef as ReactComponent };